import styled from "styled-components";

import { Input, Select, Divider } from "antd";

export const ContentDivider = styled(Divider)`
  border: solid 0.5px #e8e8e8;
  margin-top: 20px;
  margin-bottom: 15px;
`;
export const QueryResult = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  margin: ${props => props.theme.spacing.paddings.webTwiceBase};
  font-weight: ${props => props.theme.fontWeight.bold};
  display: block;
`;

export const Searchbar = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 0px;
  @media only screen and (max-width: 990px) {
    flex-wrap: wrap;
    border: none;
  }
`;

export const GrantsSearchContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};  
  @media only screen and (max-width: 990px) {
    border: none;
  }
`;

export const SearchInput = styled(Input)``;

export const MobileGrantWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: flex;
    background: blue;
    width: 100%;
  }
`;
//#endregion

export const ModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: 800px;
  // background:white;
`;

export const ModalContainer = styled.div`
  overflow: hidden;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.6);
`;

export const TimeFrame = styled.div`
  width: 200px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #d4d4d4;
  line-height: 32px;
  padding-left: 20px;
  background: white;
  font-size: 14px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  color: #d4d4d4;
`;

export const SelectTab = styled(Select)`
width: 200px;
margin-left: 10px;
max-width: 220px;
magin-lefft:20px;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
&.ant-select-focused {
  border: 1px solid #505050 !important;
  outline: none !important;
  outline-width: 1px !important;
  box-shadow: none !important;
}
&.ant-select-focused:not(.grantSelectBox) .ant-select-selection {
 border: none !important;
 outline: none !important;
 box-shadow: none !important;
}
.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.placeholder};
}
.ant-select-selection--multiple .ant-select-selection__placeholder {
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.placeholder};
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
}

.ant-select-selection {
  border-radius: 0px;
  overflow: hidden;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.placeholder};
  .ant-select-selection__rendered {
    line-height: 40px !important;
  }
}

.ant-select-selection--multiple .ant-select-selection__placeholder {
}
.ant-select-arrow {
  color: ${props => props.theme.colors.dropdownArrow};
  width: 40px;
  height: 100%;
  top: 6px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.greyColor};
}
.ant-select-selection--multiple {
  min-height: 40px;
  height: auto;
}
.ant-select-selection {
  border-radius: 0px;
  // width: 160px;
  // overflow-x: auto;
  // text-overflow: ellipsis
  padding-right: 22px;
}

.ant-select-selection--multiple > ul > li,
.ant-select-selection--multiple .ant-select-selection__rendered > ul {
  text-overflow: ellipsis;
}
.ant-select-selection--multiple > ul > li,
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  // line-height:32px;
  // height:32px;
}

.ant-select-selection--multiple .ant-select-selection__choice {
  color: ${props => props.theme.fontColors.textColor};
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  // margin-bottom: 30px;
  margin: 0;
  width: 170px;
}
@media only screen and (min-width: 728px) and (max-width: 1023px) {
  width: 200px;
}
@media only screen and (min-width: 1023px) and (max-width: 1439px) {
  width: 170px;
}
`;

export const GrantSearchLabel = styled.label`
  margin: 0px 10px 0px 20px;
  line-height: 40px;

  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color:${props => props.theme.fontColors.textColor};
`;

export const HiddenFrequency = styled.div`
  display: none;
`;
